import { __awaiter } from "tslib";
/**
 * 组件使用场景：成交
 * */
import React, { Component } from 'react';
import { ConfigProvider, Modal, Form, Input } from 'antd';
import ReactDOM from 'react-dom';
import zh_CN from 'antd/es/locale/zh_CN';
import { dispatch } from '@@/store';
import { CHECK_phonebuyerCode } from '@/shared/reqexp';
class DealCarMsg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            selectData: {},
        };
        this.cancel = this.cancel.bind(this);
        this.handleOK = this.handleOK.bind(this);
    }
    cancel() {
        this.setState({
            show: false,
        });
        this.callback = undefined;
    }
    handleOK() {
        this.props.form.validateFields()
            .then((data) => {
            const { phoneCode } = data;
            const { auctionId } = this.state.selectData;
            console.log(this.state.selectData);
            dispatch.carOperate.addBuyerMsg({
                auctionId,
                phoneCode,
                callback: () => {
                    this.callback && this.callback();
                    this.setState({
                        show: false,
                    });
                },
            });
        });
    }
    show(selectData, callback) {
        this.setState({
            show: true,
            selectData,
        });
        callback && (this.callback = callback);
    }
    render() {
        const { show } = this.state;
        return (<ConfigProvider locale={zh_CN}>
        <Modal title="请输入买家手机号/号牌" visible={show} onCancel={this.cancel} onOk={() => {
            this.handleOK();
        }} afterClose={() => {
            this.props.form.resetFields();
        }}>
          <Form>
            <Form.Item>
              {this.props.form.getFieldDecorator('phoneCode', {
            rules: [
                {
                    pattern: CHECK_phonebuyerCode,
                    message: '请输入正确的手机号/号牌',
                },
                {
                    required: true,
                    message: '请输入买家手机号/号牌',
                },
            ],
        })(<Input max={11} placeholder={'请输入买家手机号/号牌'}/>)}
            </Form.Item>
          </Form>
        </Modal>
      </ConfigProvider>);
    }
}
DealCarMsg.defaultProps = {};
const DealCarMsgComponent = Form.create()(DealCarMsg);
let componentRef = '';
const createAbortiveAuction = () => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    componentRef = React.createRef();
    const component = (<>
      <DealCarMsgComponent wrappedComponentRef={componentRef}/>
    </>);
    ReactDOM.render(component, div);
};
export default function dealCar(data, callback) {
    const { auctionIdStr, buyerCode } = data;
    if (!buyerCode) {
        showDealCarAddMsg({
            auctionId: auctionIdStr,
        }, callback);
        return;
    }
    Modal.confirm({
        title: '是否确认成交给该买家用户？',
        content: '',
        onOk() {
            dispatch.carOperate.dealCar({
                auctionId: auctionIdStr,
                callback,
            });
        },
    });
}
const showDealCarAddMsg = function (selectData, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!componentRef) {
            yield createAbortiveAuction();
        }
        console.log(componentRef);
        componentRef.current.show(selectData, callback);
    });
};
